/* unplugin-vue-components disabled */import script from "./courseCard.vue?vue&type=script&setup=true&lang=js"
export * from "./courseCard.vue?vue&type=script&setup=true&lang=js"

import "./courseCard.vue?vue&type=style&index=0&id=38be5c73&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38be5c73"]])

export default __exports__